import React, { createContext, useEffect } from 'react';
import { useColorScheme } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { UnistylesRuntime } from 'react-native-unistyles';
import { asHexColor } from '../services/colors';

interface ThemeContextValue {
    toggleTheme: () => Promise<void>;
}

const defaultValue: ThemeContextValue = {
    toggleTheme: async () => { }
};

const ThemeContext = createContext(defaultValue);

export const ThemeProvider = ({ children }: { children: React.ReactNode | undefined; }) => {
    const colorScheme = useColorScheme();

    if (!UnistylesRuntime.themeName) {
        UnistylesRuntime.setTheme(colorScheme ?? 'light');
    }

    useEffect(() => {
        // Load saved theme from storage
        const getTheme = async () => {
            try {
                const savedTheme = await AsyncStorage.getItem('theme');
                if (savedTheme) {
                    UnistylesRuntime.setTheme(savedTheme as Theme);
                }
            } catch (error) {
                console.error('Error loading theme:', error);
            }
        };
        getTheme();
    }, []);

    useEffect(() => {
        if (window.AndroidBridge?.setThemeColor) {
            window.AndroidBridge.setThemeColor(UnistylesRuntime.themeName, asHexColor(UnistylesRuntime.themeName === 'light' ? '#000028' : '#181A1B'));
        }
    }, [UnistylesRuntime.themeName]);

    const toggleTheme = async () => {
        let newTheme: Theme = 'light';
        if (UnistylesRuntime.themeName === 'light') {
            newTheme = 'lightAlt';
        }
        if (UnistylesRuntime.themeName === 'lightAlt') {
            newTheme = 'dark';
        }
        UnistylesRuntime.setTheme(newTheme);

        // Save selected theme to storage
        await AsyncStorage.setItem('theme', newTheme);
    };

    return (
        <ThemeContext.Provider value={{ toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
export default ThemeContext;
